import { createRouter, createWebHashHistory } from 'vue-router';
import { BASE_URL } from '@/config.js';

const routes = [
  {
    path: '',
    name: 'HomeView',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/login',
    name: 'LoginView',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/otp',
    name: 'Otp',
    component: () => import('../views/OtpView.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../views/DashboardView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('../views/CalendarView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/leads',
    name: 'Leads',
    component: () => import('../views/LeadsView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/leads/:id',
    name: 'LeadsIdView',
    component: () => import('../views/LeadsIdView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/newlead/',
    name: 'NewLeadsIdView',
    component: () => import('../views/NewLeadsIdView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: () => import('../views/InvoicesView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/post/:postId',
    name: 'PostView',
    component: () => import('../views/PostView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/ia',
    name: 'IaView',
    component: () => import('../views/IaView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chatia',
    name: 'ChatIaView',
    component: () => import('../views/ChatIaView.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'HomeView' },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// Função para verificar a validade do token via API
async function validateToken() {
  const token = localStorage.getItem('token');
  if (!token) {
    console.log('Aqui localStorage')
    console.log(localStorage)
    console.log('Token ausente.')
    console.warn('Token ausente.');
    return false;
  }

  try {
    const response = await fetch(`${BASE_URL}/api_client/v1.0/validate_token/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ 
        token: token,
      }),
    });
    
    console.log("TOKEN A ENVIAR:", token);
    console.log("Status da Resposta:", response.status);
    console.log("Content-Type:", response.headers.get('Content-Type'));
    
    if (response.ok && response.headers.get('Content-Type')?.includes('application/json')) {
      const data = await response.json();
      console.log("Resposta da API:", data);
      return data;
    } else {
      console.error("Resposta inesperada ou erro na API");
      const errorText = await response.text(); // Lê o corpo como texto para depuração
      console.error("Corpo da Resposta:", errorText);
      throw new Error(`Erro na API: ${response.status} - ${errorText}`);
    }

  } catch (error) {
    console.error('Erro ao validar o token:', error);
    return false;
  }
}

// Guarda global para proteger rotas
router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth) {
    const isValid = await validateToken();
    if (!isValid) {
      alert('Sessão expirada. Faça login novamente.');
      localStorage.removeItem('token'); // Limpa o token inválido
      next({ name: 'LoginView' });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
